
    import Vue from 'vue';
    import XSummary from '@/apps/shared/components/summary.vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import { SummaryDetails } from '@/apps/shared/models/summaryDetails';
    import ParamCotizService from '@/apps/shared/services/ParamCotizOfSession-service';
    import DateService from '@/apps/shared/utils/formatDate';
    import saveEmissionService from '@/apps/shared/services/saveEmission-service';

    export default Vue.extend({
        name: 'TravelAssistanceSummary',
        components: {
            XSummary,
        },
        data() {
            return {
                productDetails: {
                    effectDate: null,
                    expirationDate: null,
                    name: null,
                    email: null,
                    telephone: null,
                    cover: null,
                    planDescription: null,
                    firstPaymentFee: null,
                    firstPaymentFeeUsd: null,
                    capital: null,
                    undiscountedPrice: null,
                    undiscountedPriceUsd: null,
                    rate: null,
                    cupeUrl: null,
                    breadcrumbItems: [
                        { text: 'Inicio', path: '/asistencia-viajero' },
                        { text: 'Resumen', path: '/asistencia-viajero/resumen' },
                    ],
                    icon: {
                        src: '/Logos/asistencia-al-viajero.svg',
                        alt: 'Asistencia al Viajero',
                        title: 'Asistencia al Viajero'
                    },
                    product: '/asistencia-viajero'
                } as SummaryDetails,
                GUiD: null,
                referente: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Asistencia al Viajero';
                const actualPath = '/asistencia-viajero';
                const actualStep = 'summary';

                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, null);
                }
                catch (error) {
                    const statusCode = error.response?.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultTravelAssistanceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            formatDateFromSession(dateValue) {
                if (!dateValue) return '';
                var d = new Date(dateValue);
                if (isNaN(d.getTime())) return '';
                return DateService.formatDate(d);
            },

            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");

                const contratante = JSON.parse(sessionStorage.getItem('contratante'));
                const planSelected = JSON.parse(sessionStorage.getItem('SelectedTravelPlan'));
                const travelData = JSON.parse(sessionStorage.getItem('TravelDetailsData'));

                // Fechas de vigencia (salida / regreso)
                if (travelData) {
                    this.productDetails.effectDate = this.formatDateFromSession(travelData.departureDate);
                    this.productDetails.expirationDate = this.formatDateFromSession(travelData.returnDate);
                }

                // Datos del contratante
                if (contratante) {
                    this.productDetails.name = contratante.firstName + ' ' + contratante.lastName;
                    this.productDetails.email = contratante.email;
                    this.productDetails.telephone = contratante.areaCode + '-' + contratante.telephone;
                }

                // Datos del plan
                if (planSelected) {
                    this.productDetails.planDescription = planSelected.name;

                    this.productDetails.firstPaymentFee = planSelected.premioMensualPesosACobrar
                        ? Number(planSelected.premioMensualPesosACobrar).toLocaleString('es-AR', { maximumFractionDigits: 0 })
                        : '';
                    // Valor informativo en USD (el producto se tarifa en dólares).
                    this.productDetails.firstPaymentFeeUsd = planSelected.priceFormatted || '';
                    this.productDetails.capital = null;
                    this.productDetails.undiscountedPrice = null;
                    // Descuento web: tachado en USD solo si el plan se cotizó con descuento
                    const hasDiscount = planSelected.rate != null && planSelected.undiscountedPriceFormatted;
                    this.productDetails.undiscountedPriceUsd = hasDiscount ? planSelected.undiscountedPriceFormatted : null;
                    this.productDetails.rate = hasDiscount ? planSelected.rate : null;
                    this.productDetails.cover = planSelected.covers
                        ? planSelected.covers.filter(c => c.included).map(c => ({ coverDescription: c.description }))
                        : [];
                }
            },

            setSessionParams() {
                const rawContratante = JSON.parse(sessionStorage.getItem('contratante'));
                const rawPlanSelected = JSON.parse(sessionStorage.getItem('SelectedTravelPlan'));
                const rawTravelData = JSON.parse(sessionStorage.getItem('TravelDetailsData'));
                const rawPassengers = JSON.parse(sessionStorage.getItem('passengers'));
                const rawLeadId = JSON.parse(sessionStorage.getItem('LeadId'));
                const rawDataTabHome = JSON.parse(sessionStorage.getItem('DataTabHome'));

                const payload = {
                    productId: 1018,
                    pricingId: rawPlanSelected ? rawPlanSelected.pricingId : null,
                    leadId: rawLeadId,
                    contratante: {
                        firstName: rawContratante ? rawContratante.firstName : '',
                        lastName: rawContratante ? rawContratante.lastName : '',
                        documentNumber: rawContratante ? rawContratante.documentNumber : '',
                        documentType: rawContratante ? rawContratante.documentType : null,
                        areaCode: rawContratante ? rawContratante.areaCode : '',
                        telephone: rawContratante ? rawContratante.telephone : '',
                        email: rawContratante ? rawContratante.email : '',
                        ivaCondition: rawContratante ? rawContratante.ivaCondition : null,
                        localityName: rawContratante ? rawContratante.localityName : null,
                    },
                    plan: {
                        name: rawPlanSelected ? rawPlanSelected.name : '',
                        priceFormatted: rawPlanSelected ? rawPlanSelected.priceFormatted : '',
                    },
                    travelData: {
                        destination: rawTravelData ? rawTravelData.destination : null,
                        tripType: rawTravelData ? rawTravelData.tripType : null,
                        departureDate: rawTravelData ? rawTravelData.departureDate : null,
                        returnDate: rawTravelData ? rawTravelData.returnDate : null,
                        passengersCount: rawTravelData ? rawTravelData.passengersCount : 0,
                    },
                    passengers: rawPassengers || [],
                    referente: this.referente,
                };

                const jsonString = JSON.stringify(payload);

                return ParamCotizService.setParamCotiz(jsonString)
                    .then(guid => {
                        this.GUiD = guid;
                    })
                    .catch(err => {
                        console.error("Error en setSessionParams:", err);
                    });
            },

            SaveEmission() {
                const owner = JSON.parse(sessionStorage.getItem("contratante")) || {};
                const planSelected = JSON.parse(sessionStorage.getItem("SelectedTravelPlan"));
                const passengers = JSON.parse(sessionStorage.getItem("passengers")) || [];

                const pricingId = planSelected ? planSelected.pricingId : null;

                // Dirección cargada en el front en Datos del Contratante (persona de BUP sin localidad, igual que AP)
                const usingFront = owner?.addresFromFront === true;

                const request = {
                    PricingId: pricingId,
                    Birthday: owner.birthday ? new Date(owner.birthday) : null,
                    CityCode: null,
                    ClientFirstName: owner.firstName || "",
                    ClientLastName: owner.lastName || "",
                    DocumentNumber: owner.documentNumber ? Number(owner.documentNumber) : 0,
                    DocumentType: owner.documentType ? (owner.documentType.id || owner.documentType) : "",
                    EffectDate: new Date(),
                    ClientAddress: {},
                    Email: owner.email || "",
                    // Condición fiscal elegida en Datos del Contratante: sin ella el tomador queda con
                    // IvaConditionId null cuando BUP no la informa y el Tarifador rechaza la emisión.
                    IvaConditionId: owner.ivaCondition ? Number(owner.ivaCondition.id) : (owner.ivaConditionFiscalId || null),
                    Phones: [{ areaCode: owner.areaCode, phoneNumber: owner.telephone }],
                    ProducerCode: null,
                    ReceivePromotion: false,
                    RiskAddress: {},
                    ZipCode: null,
                    PeopleToCover: passengers,
                };

                if (usingFront) {
                    request.ClientAddress = {
                        StreetName: owner.streetName,
                        StreetNumber: owner.numDom,
                        City: { CityPostalCode: owner.zipCode }
                    };
                    request.CityCode = owner.localityId;
                }
                // El backend responde 200 con validationResult cuando el Tarifador rechaza la
                // emisión: sin este chequeo el flujo seguía CUPE y se cobraba igual.
                return saveEmissionService.TravelAssistanceSaveEmission(JSON.stringify(request))
                    .then(response => {                        
                        const message = response && response.validationResult ? response.validationResult.errorMessage : null;

                        if (message && message !== 'Los datos para la emisión se guardaron correctamente') {
                            throw new Error(message);
                        }

                        return response;
                    });
            },

            getCUPE() {
                const email = "";
                const productId = 1018;
                NF.UI.Page.block();
                return CUPEService.GetCUPEUrl(productId, email, this.GUiD)
                    .then(response => {
                        this.productDetails.cupeUrl = response.preferenceMessage;
                    })
                    .catch((error) => {
                        console.error('Error al obtener la URL:', error);
                    })
                    .finally(() => NF.UI.Page.unblock());
            },
        },
        async mounted() {
            // GTM: 'carga' del resumen = segundos desde que empieza a cargar hasta que queda listo para pagar
            const timeStart = new Date().getTime();
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;

                await this.pageCustomization();

                const parallelPromises = [
                    this.updateByProductGoogleAnalytics(),
                    this.getInitData(),
                    this.setSessionParams()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                await this.SaveEmission();

                await this.getCUPE();

                const contratante = JSON.parse(sessionStorage.getItem('contratante'));
                const planSelected = JSON.parse(sessionStorage.getItem('SelectedTravelPlan'));
                const secondCharge = Math.round((new Date().getTime() - timeStart) / 1000);
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': contratante ? contratante.email : null,
                    'referente': this.referente,
                    'product': 'asistencia-viaje',
                    'event': 'cotizador-asistencia-viaje-resumen',
                    'carga': secondCharge,
                    'value': planSelected && planSelected.premioMensualPesosACobrar ? Math.round(Number(planSelected.premioMensualPesosACobrar)) : null
                });
                window.globalThis._qsie = window.globalThis._qsie || [];
                window.globalThis._qsie.push('cotizador-asistencia-viaje-resumen');

            } catch (error) {
                // Sin emisión guardada no se genera CUPE: se avisa en vez de dejar la pantalla muda.
                // El 409 significa que la cotización ya no está en sesión: hay que volver a cotizar.
                // ProvinceMismatch: el tomador no es de la provincia cotizada; se vuelve al inicio a cambiar la localidad.
                const statusCode = error.response?.status;
                const retryActions = statusCode === 409
                    ? [() => {
                        sessionStorage.removeItem("TravelQuotationData");
                        sessionStorage.setItem("pressBackFromPlans", "true");
                        this.$router.push({ name: 'travelAssistance-tab-two' });
                    }]
                    : error.response?.data?.code === 'ProvinceMismatch'
                        ? [() => {
                            sessionStorage.setItem("pressBack", "true");
                            this.$router.push({ name: 'travelAssistance-tab-One' });
                        }]
                        : [];

                this.Bus.$emit('show-service-fail', statusCode, retryActions);
            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
